export class ApproveBookingRequest {
    id: number;
    user: string;
    password: string;
    decryptedPassword: string;
    agrisSession: string;
    sessionId: string;
    tenantId: string;
    bankCode: string;
    status:string;
    isSameNumber :boolean
    constructor() {
        this.user = '';
        this.password = '';
        this.decryptedPassword = '';
        this.agrisSession = '';
        this.sessionId = '';
        this.tenantId = '';
        this.bankCode = '';
        this.isSameNumber =false;
        // this.status = '';
    }
}